export default __webpack_public_path__ + "assets/kazakhstan-flag.png";